import React, { useEffect } from 'react';
import { Download, FileText, Image, Film, File, Loader2, Calculator } from 'lucide-react';
import AppendixWrapper from './common/AppendixWrapper';
import { useAppendix } from '../context/AppendixContext';
import { useSalesData } from '../context/SalesDataContext';
import WhatsAppAttachmentItem from './WhatsAppAttachmentItem';

const WhatsAppAttachments = ({
    isOpen,
    onClose,
    attachments = [],
    waStatus,
    onAnalyze,
    onCompare,
    analyzedFiles = new Set(),
    extractedData = {},
    onDownload
}) => {
    const { registerAppendix, setAppendixStatus } = useAppendix();
    const { priceData } = useSalesData();
    const id = 'whatsapp-attachments';
    
    const hasImaginaPrice = priceData?.imagina && Object.keys(priceData.imagina).length > 0;

    useEffect(() => {
        registerAppendix(id, {
            title: 'Adjuntos WhatsApp',
            icon: FileText
        });
    }, [registerAppendix]);

    useEffect(() => {
        setAppendixStatus(id, isOpen);
    }, [isOpen, setAppendixStatus]);
    const getFileIcon = (mimeType) => {
        if (!mimeType) return <File size={16} className="text-slate-400" />;
        if (mimeType === 'application/pdf') return <FileText size={16} className="text-red-400" />;
        if (mimeType.startsWith('image/')) return <Image size={16} className="text-blue-400" />;
        if (mimeType.startsWith('video/')) return <Film size={16} className="text-purple-400" />;
        return <File size={16} className="text-slate-400" />;
    };

    const formatSize = (bytes) => {
        if (!bytes) return '';
        if (bytes < 1024) return `${bytes} B`;
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    };

    return (
        <AppendixWrapper 
            id={id} 
            title="Adjuntos WhatsApp" 
            icon={FileText} 
            className="w-[300px]"
            onClose={onClose}
            defaultPosition={{ x: window.innerWidth - 350, y: 100 }}
        >
            {/* Content Container */}
            <div className="flex flex-col bg-slate-950">

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-3 space-y-2 custom-scrollbar max-h-[400px]">
                {waStatus === 'waiting' && attachments.length === 0 && (
                    <div className="py-8 flex flex-col items-center justify-center bg-amber-500/5 rounded-lg border border-amber-500/20">
                        <Loader2 size={20} className="text-amber-400 animate-spin mb-3" />
                        <span className="text-[11px] text-amber-400 font-bold uppercase tracking-wider">Esperando ficheros...</span>
                        <span className="text-[9px] text-slate-500 mt-1">El cliente enviará los documentos por WhatsApp</span>
                    </div>
                )}

                {attachments.map((att, idx) => (
                    <WhatsAppAttachmentItem
                        key={att.id || idx}
                        att={att}
                        extractedData={extractedData}
                        onAnalyze={onAnalyze}
                        onCompare={onCompare}
                        onDownload={onDownload}
                    />
                ))}
            </div>

            {/* Footer */}
            {waStatus === 'completed' && attachments.length > 0 && (
                <div className="p-2.5 bg-emerald-900/20 border-t border-emerald-700/30 text-center">
                    <p className="text-[9px] text-emerald-500 font-bold uppercase tracking-wider">
                        ✓ Recepción completada
                    </p>
                </div>
            )}
            </div>
        </AppendixWrapper>
    );
};

export default WhatsAppAttachments;
